import React from "react";
import owlLogo from "../assets/metis-owl-logo.png";

// Small brand logo mark.
export const Logo = ({ className = "", showText = true }) => (
  <div className={`flex items-center gap-2.5 ${className}`}>
    <div className="relative">
      <img
        src={owlLogo}
        alt=""
        aria-hidden="true"
        width="34"
        height="34"
        className="block h-[34px] w-[34px] object-contain"
      />
    </div>
    {showText && (
      <div className="leading-none">
        <span className="font-display text-[15px] font-semibold tracking-tight text-white">
          Métis
        </span>
        <span className="font-display text-[15px] font-semibold tracking-tight text-neon-g">
          {" "}Tech Labs
        </span>
      </div>
    )}
  </div>
);
